import { forwardRef, Inject, Injectable } from '@angular/core';

import { ApiService }      from '../api/api.service';
import { MessagesService } from '../messages/messages.service';

export interface CrudGridInstance<T = any> {
  data: Array<T>;
  editable: boolean;
  toggleEditMode(row: T, index: number): void;
  editRow(row: T, index: number): void;
  addRow(): void;
  removeRow(row: T, index: number, url: string, identifier: string): any;
}

export abstract class CrudGridService {
  abstract create<T = any>(): CrudGridInstance<T>;
}

@Injectable()
export class CrudGridServiceImpl extends CrudGridService {
  constructor(
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => MessagesService)) private messagesService: MessagesService
  ) {
    super();
  }

  create<T = any>(): CrudGridInstance<T> {
    const apiService = this.apiService;
    const messagesService = this.messagesService;

    return {
      data: [],
      editable: true,

      toggleEditMode(row: any, index: number): void {
        if (row.id) {
          row.editing = !row.editing;
        } else {
          this.data.splice(index, 1);
        }
      },

      editRow(row: any, _index: number): void {
        const activeRow = this.data.filter((item: any) => item.editing);

        if (activeRow.length) {
          (activeRow[0] as any).editing = false;
        }

        (row as any).editing = true;
      },

      addRow(): void {
        this.data.push({} as T);
        this.editRow(this.data[this.data.length - 1], this.data.length - 1);
      },

      removeRow(row: any, index: number, url: string, identifier: string): any {
        if (row[identifier]) {
          const promise = apiService.delete(url, row[identifier]);

          promise.catch((err: any) => {
            messagesService.error(err);
          });

          return promise;
        } else {
          this.data.splice(index, 1);
          return Promise.resolve();
        }
      }
    };
  }
}

export function CrudGridAPIService ($q: any, workshopAPI: any, messages: any) {
  return function () {
    return {
      data: [],
      editable: true,
      toggleEditMode: function (row, index) {
        if (row.id) {
          row.editing = !row.editing;
        } else {
          this.data.splice(index, 1);
        }
      },
      editRow: function (row, index) {
        var activeRow = this.data.filter(function (item) {
          return item.editing;
        });

        if (activeRow.length) {
          activeRow[0].editing = false;
        }

        row.editing = true;
      },
      addRow: function () {
        this.data.push({});
        this.editRow(this.data[this.data.length-1]);
      },
      removeRow: function (row, index, url, identifier) {
        var _this = this;
        var promise;

        if (row[identifier]) {
          promise = workshopAPI.delete(url, row[identifier])

          promise.catch(function (err) {
            messages.error(err);
          });

          return promise;
        }
        else {
          _this.data.splice(index, 1);

          return Promise.resolve();
        }
      }
    };
  };
}